// extracted by mini-css-extract-plugin
export default {"site-name":"Banner_site-name__3ktAO","site-name-link":"Banner_site-name-link__Ge8oO"};